import { Form } from 'antd';

import { FetchImage } from 'components';

import { TFieldProps } from 'types';

const { Item } = Form;

export const FormImage = ({
  name,
  label,
  rules,
  tooltip,
  imgWidth = 80,
  itemClassName,
}: Omit<TFieldProps, 'type'>) => (
  <Item
    name={name}
    rules={rules}
    label={label}
    tooltip={tooltip}
    labelAlign='left'
    className={itemClassName}
    valuePropName='src'
  >
    <FetchImage
      width={imgWidth}
      height={imgWidth}
    />
  </Item>
);
